<template>
  <div class="hello">
    <div class="d-flex justify-content-center mb-3">
      <b-spinner label="Login..." style="width: 5rem; height: 5rem;" ></b-spinner>
    </div>
  </div>
</template>

<script>
import CommonMixin from "@/components/mixin/CommonMixin";
import {getAccessTokenApi} from "@/api/kakao";

export default {
  name: 'KakaoLoginLendingView',
  mixins: [CommonMixin],
  data () {
    return {
    }
  },
  methods: {

  },
  created() {

  },
   async mounted() {
     const code = this.getRouterQueryParam("code");
     if (code) {
       const accessToken = await getAccessTokenApi(code, `${window.location.protocol}//${window.location.host}/kakao-login-lending`);
       if (accessToken) {
         console.log(accessToken.data)
       }
       return
     }
     alert('코드가 없으면 안돼! 홈으로!')
     location.replace(`${window.location.protocol}//${window.location.host}`)
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
